module.exports = __webpack_public_path__ + "resources/img/img_speech_to_text.a217f4a6bf34a24a01c822a6e38f4557.png";